export enum Category {
  ALL = '0',
  PERSONAL_CARE = '12.1',
  MAKEUP = '12.1.3.1.5',
  HAIR_CARE = '12.1.3.1.1',
  SKIN_CARE = '12.1.3.1.2',
  FRAGRANCES = '12.1.3.1.3',
  BEAUTY = '12.1.3.1',
  OTHER_PERSONAL_CARE = '12.1.3.2',
  HYGIENE = '12.1.3.1.4',
  SPIRITS = '02.1.1',
  MINERAL_WATER = '01.2.2',
  BEAUTY_SERVICES = '12.1.1',
  TOTAL_BEAUTY = 'total_beauty',
  FOOD_AND_BEVERAGES = '01',
  ALCOHOLIC_BEVERAGES_TOBACCO = '02',
  CLOTHING_AND_FOOTWEAR = '03',
  HOUSING = '04',
  FURNISHINGS_HOUSEHOLD_EQUIPMENT = '05',
  HEALTH = '06',
  TRANSPORT = '07',
  COMMUNICATIONS = '08',
  RECREATION_AND_CULTURE = '09',
  CULTURAL_SERVICES = '09.4.2',
  EDUCATION = '10',
  RESTAURANTS_AND_HOTELS = '11',
  MISCELLANEOUS = '12',
  JEWELRY = '12.3.1',
}
